/** @module @csi/widget/CountToggle */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"underscore",
	"dojo/text!./CountToggle.html"
], function(declare,_WidgetBase,_TemplatedMixin,_,template) {
	
	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-count-toggle",
		templateString: template,
		
		/** @property {boolean} checked - true if toggled on */
		checked: false,

		/** @property {number} count - count to display */
		count: 0,
		
		/** @property {string} countClass - CSS class to apply to count (such as for coloring) */
		countClass: "",
		
		/** @property {CountToggle[]} group - toggle buttons in group; this widget will automatically be added to array if specified */
		group: null,
		
		/** @property {string} label - label to display after count */
		label: "",
		
		/**
		 * @override
		 * Add widget to group
		 */
		postCreate: function() {
			this.inherited(arguments);
			
			if (this.group) {
				this.group.push(this);
			}
		},
		
		/**
		 * Extension point for when widget is clicked
		 */
		onClick: function() { },
		
		/**
		 * Click event handler
		 * @param {Event} e 
		 */
		_onClick: function(e) {
			if (!this.checked) {
				// toggle off other checked widget in group
				const w = _.findWhere(this.group, {checked: true});
				
				if (w) {
					w.set("checked", false);
				}
				
				this.set("checked", true);
				this.onClick();
			}
			
			e.stopPropagation();
		},
		
		/**
		 * Apply CSS when checked
		 */
		_setCheckedAttr: function(value) {
			this._set("checked", value);
			$(this.domNode).toggleClass(this.baseClass + "-checked", value);
		}
	});
});